import React from "react";
import { track } from "@/lib/analytics";

/**
 * Fixed-position WhatsApp button. Bottom-left, always visible on every
 * page. Uses the official WhatsApp brand green (#25D366) and SVG icon.
 * The link opens the wa.me deep link with a prefilled message so the
 * agent immediately knows the lead's intent.
 */
export default function WhatsAppFloat() {
  const href =
    "https://wa.me/34626411029?text=Hola%2C%20me%20interesa%20el%20AOVE%20de%20Cortijo%20Santa%20Mar%C3%ADa";
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Hablar por WhatsApp"
      data-testid="whatsapp-float"
      onClick={() => track("cta_click", { cta: "whatsapp_float", location: "floating" })}
      className="fixed bottom-5 left-5 z-[60] group inline-flex items-center justify-center w-14 h-14 sm:w-15 sm:h-15 rounded-full bg-[#25D366] shadow-[0_10px_30px_-8px_rgba(0,0,0,0.35)] hover:shadow-[0_14px_36px_-8px_rgba(37,211,102,0.6)] hover:scale-105 transition-all duration-300"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-50 animate-ping group-hover:hidden" />
      <svg
        viewBox="0 0 24 24"
        className="relative w-7 h-7 sm:w-8 sm:h-8 text-white"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M17.498 14.382c-.301-.15-1.767-.867-2.04-.966-.273-.099-.471-.15-.671.15-.197.296-.769.964-.944 1.162-.175.197-.348.223-.646.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.511-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
      </svg>
    </a>
  );
}
